/**
 * Tea Education Modal System
 * Handles modal opening, closing, and content switching
 */

document.addEventListener('DOMContentLoaded', function() {
  // Elements
  const modal = document.getElementById('teaEducationModal');
  const modalContents = modal.querySelectorAll('.tea-modal-content');
  const triggers = document.querySelectorAll('.tea-education-icon-button');
  const closeButtons = modal.querySelectorAll('.tea-modal-close, .tea-close-modal');
  
  // State
  let currentType = null;
  
  /**
   * Open modal with specific content type
   */
  function openModal(type) {
    // Hide all content
    modalContents.forEach(content => {
      content.classList.remove('active');
    });
    
    // Show requested content
    const targetContent = modal.querySelector(`[data-content-type="${type}"]`);
    if (targetContent) {
      targetContent.classList.add('active');
      currentType = type;
    }
    
    // Show modal
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
    
    // Track analytics
    if (typeof window.Shopify !== 'undefined') {
      // Shopify Analytics
      if (window.Shopify.analytics) {
        window.Shopify.analytics.track('Tea Education Modal Opened', {
          type: type,
          product_id: window.ShopifyAnalytics?.meta?.product?.id || null
        });
      }
    }
    
    // Google Analytics (if available)
    if (typeof gtag !== 'undefined') {
      gtag('event', 'education_modal_open', {
        'event_category': 'engagement',
        'event_label': type,
        'value': 1
      });
    }
  }
  
  /**
   * Close modal
   */
  function closeModal() {
    modal.classList.remove('active');
    document.body.style.overflow = '';
    currentType = null;
  }
  
  // Event Listeners
  
  // Trigger clicks
  triggers.forEach(trigger => {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const type = this.dataset.modalType;
      if (type) {
        openModal(type);
      }
    });
  });
  
  // Close button clicks
  closeButtons.forEach(button => {
    button.addEventListener('click', closeModal);
  });
  
  // Overlay click to close
  modal.addEventListener('click', function(e) {
    if (e.target === modal) {
      closeModal();
    }
  });
  
  // ESC key to close
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.classList.contains('active')) {
      closeModal();
    }
  });
  
  // Prevent scroll when modal is open
  let scrollPosition = 0;
  
  modal.addEventListener('transitionstart', function() {
    if (modal.classList.contains('active')) {
      scrollPosition = window.pageYOffset;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollPosition}px`;
      document.body.style.width = '100%';
    }
  });
  
  modal.addEventListener('transitionend', function() {
    if (!modal.classList.contains('active')) {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, scrollPosition);
    }
  });
});